/* Contents: numbered list built from the post's headings, shown as a sticky
   column on desktop and as a floating bar on smaller screens. Numbers match
   the CSS counter printed next to each h2. */
(function () {
    'use strict';

    var content = document.querySelector('[data-content]');
    var toc = document.querySelector('[data-toc]');
    var bar = document.querySelector('[data-toc-bar]');
    if (!content || (!toc && !bar)) {
        return;
    }

    // Only top-level headings: the same ones the CSS counter numbers
    var headings = Array.prototype.filter.call(content.querySelectorAll(':scope > h2, :scope > h3'), function (h) {
        return h.textContent.trim() !== '';
    });

    var sectionCount = headings.filter(function (h) {
        return h.tagName === 'H2';
    }).length;

    if (sectionCount < 2) {
        return;
    }

    function pad(n) {
        return n < 10 ? '0' + n : String(n);
    }

    function slugify(text, index) {
        var slug = text.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
            .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        return slug || 'section-' + index;
    }

    // Authors who number their own headings ("1. Setup") keep their numbers;
    // the printed counter steps aside and the contents list drops the prefix.
    var MANUAL = /^\s*\d+[.)]\s+/;
    var manual = headings.some(function (h) {
        return h.tagName === 'H2' && MANUAL.test(h.textContent);
    });

    var entries = [];
    var section = 0;

    headings.forEach(function (heading, index) {
        if (!heading.id) {
            heading.id = slugify(heading.textContent, index);
        }
        var isSection = heading.tagName === 'H2';
        if (isSection) {
            section += 1;
        }
        entries.push({
            heading: heading,
            label: manual ? heading.textContent.trim().replace(MANUAL, '') : heading.textContent.trim(),
            number: isSection ? pad(section) : '',
            sub: !isSection
        });
    });

    function render(list) {
        var links = [];
        entries.forEach(function (entry) {
            var li = document.createElement('li');
            if (entry.sub) {
                li.className = 'toc-sub';
            }
            var a = document.createElement('a');
            a.href = '#' + entry.heading.id;
            if (entry.number) {
                var num = document.createElement('span');
                num.className = 'mono';
                num.textContent = entry.number;
                a.appendChild(num);
            }
            a.appendChild(document.createTextNode(entry.label));
            li.appendChild(a);
            list.appendChild(li);
            links.push(a);
        });
        return links;
    }

    var columnLinks = [];
    var barLinks = [];

    if (toc) {
        columnLinks = render(toc.querySelector('[data-toc-list]'));
        toc.hidden = false;
    }

    var barCurrent = null;
    var barToggle = null;

    if (bar) {
        barLinks = render(bar.querySelector('[data-toc-bar-list]'));
        barCurrent = bar.querySelector('[data-toc-bar-current]');
        barToggle = bar.querySelector('[data-toc-bar-toggle]');
        bar.hidden = false;

        barToggle.addEventListener('click', function () {
            var open = !bar.classList.contains('is-open');
            bar.classList.toggle('is-open', open);
            barToggle.setAttribute('aria-expanded', String(open));
        });

        bar.addEventListener('click', function (event) {
            if (event.target.closest('a')) {
                bar.classList.remove('is-open');
                barToggle.setAttribute('aria-expanded', 'false');
            }
        });
    }

    var sections = entries.filter(function (entry) {
        return !entry.sub;
    });

    function setActive(index) {
        [columnLinks, barLinks].forEach(function (links) {
            links.forEach(function (link, i) {
                if (i === index) {
                    link.setAttribute('aria-current', 'true');
                } else {
                    link.removeAttribute('aria-current');
                }
            });
        });

        if (barCurrent) {
            var entry = entries[index];
            var sectionEntry = entry && entry.sub ? null : entry;
            var position = sectionEntry ? sections.indexOf(sectionEntry) + 1 : 0;
            barCurrent.textContent = entry
                ? (position ? pad(position) + ' / ' + pad(sections.length) + '  ' : '') + entry.label
                : barCurrent.textContent;
        }
    }

    var ticking = false;

    function onScroll() {
        var line = window.innerHeight * 0.3;
        var active = -1;
        entries.forEach(function (entry, i) {
            if (entry.heading.getBoundingClientRect().top <= line) {
                active = i;
            }
        });
        setActive(Math.max(active, 0));

        if (bar) {
            var rect = content.getBoundingClientRect();
            bar.classList.toggle('is-visible', rect.top < line && rect.bottom > window.innerHeight * 0.6);
        }
        ticking = false;
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(onScroll);
        }
    }, {passive: true});

    onScroll();
})();
